import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { Col, Form, Input, Row, Select } from "antd";
import type { PurchaseContractFormValues } from "../type";
import styles from "@/asserts/styles/formSection.module.less";

const CONTRACT_CATEGORY_OPTIONS = [
  { label: "采购合同", value: "PURCHASE" },
  { label: "服务合同", value: "SERVICE" },
  { label: "租赁合同", value: "LEASE" },
  { label: "其他合同", value: "OTHER" },
];

const CONTRACT_SUB_CATEGORY_OPTIONS = [
  { label: "原材料", value: "RAW_MATERIAL" },
  { label: "设备", value: "EQUIPMENT" },
  { label: "办公用品", value: "OFFICE_SUPPLIES" },
  { label: "IT服务", value: "IT_SERVICE" },
  { label: "物流服务", value: "LOGISTICS_SERVICE" },
  { label: "咨询服务", value: "CONSULTING_SERVICE" },
];

/**
 * 合同审查信息
 */
export function ContractReviewFormFields() {
  return (
    <div className={styles.formSection}>
      <ModalSectionHeader title="合同审查信息" />

      <div className={styles.sectionBody}>
        <Row gutter={49}>
          <Col span={8}>
            <Form.Item<PurchaseContractFormValues>
              name="contractCategory"
              label="合同类别"
              rules={[{ required: true, message: "请选择合同类别" }]}
            >
              <Select
                placeholder="请选择"
                options={CONTRACT_CATEGORY_OPTIONS}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<PurchaseContractFormValues>
              name="contractSubCategory"
              label="合同子类别"
              rules={[{ required: true, message: "请选择合同子类别" }]}
            >
              <Select
                placeholder="请选择"
                options={CONTRACT_SUB_CATEGORY_OPTIONS}
              />
            </Form.Item>
          </Col>

          <Col span={8}></Col>
        </Row>
        <Row gutter={49}>
          <Col span={24}>
            <Form.Item<PurchaseContractFormValues>
              name="contractDescription"
              label="合同描述"
              rules={[{ required: true, message: "请输入合同描述" }]}
            >
              <Input.TextArea
                rows={4}
                placeholder="请输入合同描述"
                maxLength={500}
                showCount
              />
            </Form.Item>
          </Col>
        </Row>
      </div>
    </div>
  );
}
